import { useContext } from 'react';

import TooltipContext from './context';

const useTooltipContext = () => {
  const context = useContext(TooltipContext);

  if (!context)
    throw new Error('useTooltipContext must be used within a TooltipProvider');

  return context;
};

export default useTooltipContext;
